import {createContext} from 'react';

const queHacemosContext = createContext();

export default queHacemosContext;